import { render } from "./PaintingForm.vue?vue&type=template&id=a5496e5c"
import script from "./PaintingForm.vue?vue&type=script&lang=js"
export * from "./PaintingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__